import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import listAxpoCounterInvoices from "../http/listAxpoCounterInvoices";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useAxpoCounterInvoices = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  return useQuery(["axpo-counter-invoices"], async () =>
    listAxpoCounterInvoices(await getAuthTokenBlocking(getToken, relogin))
  );
};

export default useAxpoCounterInvoices;
